import React from 'react';
import { observer } from 'mobx-react-lite';
import SiteBuilderModel from '../steps/SiteBuilder/model/SiteBuilderModel';
import DesignModel from '../steps/Design/models/DesignModel';
import fontCombos from '../steps/Design/view/fonts/fonts';
import IframeServiceInjector from '../steps/SiteBuilder/services/injectors/IframeServiceInjector';
import FrameEventMessanger from '../steps/SiteBuilder/services/frames/FrameEventMessanger';
import { CHANGE_SITE_FONTS } from '../steps/SiteBuilder/consts/events';

const OUTLINE_COLOR = '#3498DB';

const FontSelector = observer(() => {
  const selectedComboId = fontCombos.find(
    combo => combo.mainFontFamily === SiteBuilderModel.fontMap?.main?.name && combo.displayFontFamily === SiteBuilderModel.fontMap?.display?.name
  )?.id;

  const handleSelect = async (combo) => {
    const newFontMap = {
      main: { name: combo.mainFontFamily },
      display: { name: combo.displayFontFamily }
    };

    SiteBuilderModel.setFontMap(newFontMap);

    // Update the wizard data so it's saved on purchase
    DesignModel.designModelWizardData.setFormData({
      logo: DesignModel.selectedLogo?.getFileUrl() || null,
      font_main: combo.mainFontFamily,
      font_display: combo.displayFontFamily
    });

    // Send message to iframe to update fonts dynamically
    const frameEventMessanger = IframeServiceInjector.getService<FrameEventMessanger>('FrameEventMessanger');
    if (frameEventMessanger) {
      frameEventMessanger.sendMessage(CHANGE_SITE_FONTS, {
        mainFont: combo.mainFontFamily,
        displayFont: combo.displayFontFamily
      });
    }
  };

  return (
    <div>
      <div className="flex flex-col gap-4">
        {fontCombos.map((combo) => (
          <button
            key={combo.id}
            onClick={() => handleSelect(combo)}
            style={{
              border: selectedComboId === combo.id ? `3px solid ${OUTLINE_COLOR}` : '1px solid #00000026',
              borderRadius: 12,
              padding: '16px',
              background: '#fff',
              cursor: 'pointer',
              transition: 'border 0.2s, box-shadow 0.2s',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '15px',
            }}
          >
            <span
              className="block text-[20px] font-semibold leading-[100%]" 
              style={{
                color: 'var(--colorText, rgba(0, 0, 0, 0.88))',
                fontFamily: combo.displayFontFamily,
                fontStyle: 'normal',
                marginBottom: 0,
              }}
            >
              This is a headline Text
            </span>
            <span
              className="block text-[14px] font-normal leading-[100%]" 
              style={{
                color: 'var(--colorText, rgba(0, 0, 0, 0.88))',
                fontFamily: combo.mainFontFamily,
                fontStyle: 'normal',
                marginTop: 0,
              }}
            >
              This is a regular Text
            </span>
          </button>
        ))}
      </div>
    </div>
  );
});

export default FontSelector;
